export default "__VITE_ASSET__CForQsJB__"